export default __webpack_public_path__ + "static/rhodecentral-a8c8efca6432e474176bc628dcf24620.jpg";